
import { defineComponent, ref } from "vue";

import { BaseButton } from "@tager/admin-ui";

import Conditions from "@/views/CategoryForm/components/Conditions.vue";
import { FormValues } from "@/views/CategoryForm/CategoryForm.helpers";

type Props = Readonly<{ values: FormValues }>;
export default defineComponent({
  name: "ConditionPage",
  components: { Conditions, BaseButton },
  props: {
    productTypeOptionList: {
      type: Array,
      required: true,
    },
    brandListOption: {
      type: Array,
      required: true,
    },
    values: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const conditions = ref(props.values.conditions);

    function addElement() {
      conditions.value.push({
        type: null,
        productType: null,
        fieldConditions: [],
        operator: null,
        operand: "0",
        brands: [],
      });
    }

    return { conditions, addElement };
  },
});
